import { StateBlock, TagToken } from 'remarkable/lib';
import type { IRemarkableBlockExtension } from '../types';

const name = 'pageBreak';
export const pageBreakTag = '@@@ PAGEBREAK @@@';

/**
 * Inserta un salto de página donde se encuentra exactamente la línea con el tag '@@@ PAGEBREAK @@@'.
 */
export const pageBreakExtension: IRemarkableBlockExtension = {
  name,
  parser: (
    state: StateBlock,
    startLine: number,
    _endLine: number,
    checkMode: boolean,
  ): boolean => {
    const line = state.getLines(startLine, startLine + 1, 0, false);
    if (line.trim() !== pageBreakTag) return false;

    if (checkMode) return true; // Sólo validación (no emitir tokens)

    state.tokens.push({
      type: name,
      level: 0,
      lines: [startLine, startLine + 1],
    } as TagToken);

    state.line = startLine + 1; // avanzar a la siguiente línea
    return true;
  },

  replacer: () => () => `<div class="${name}"></div>`,

  styles: () => `
.${name} + * {
  page-break-before: always;
}

.${name} {
  display: none;
}

`,
};
